import type { StripeElementLocale } from '@stripe/stripe-js';
import { t } from 'i18next';

import { Language } from 'store/accounts/models';

export function createTranslationLink(key: string, defaultParams: Record<string, unknown> = {}) {
  return (params: unknown) => t(key, { ...defaultParams, ...(params as Record<string, unknown>) }) ?? '';
}

export function getStripeLocale(language: Language): StripeElementLocale {
  switch (language) {
    case Language.CN:
      return 'zh';
    case Language.EN:
      return 'en';
    case Language.ES:
      return 'es';
    case Language.VI:
      return 'vi';
    case Language.RU:
      return 'ru';
    default:
      return 'en';
  }
}

export function getAPILocale(language: string): string {
  switch (language) {
    case 'zh':
      return 'zh-CN';
    default:
      return language;
  }
}

export function getFormatterLocale(language: string) {
  if (language === Language.CN) return 'zh';

  if (!Object.values(Language).includes(language as Language)) return 'en';

  return language;
}
